import { Card, Divider, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { paymentsApi } from '../../../../api/swagger'
import useLoadingContext from '../../../../hooks/useLoadingContext'
import { useLoadingIds } from '../../../../hooks/useLoadingIds'
import { useMountEffect } from '../../../../hooks/useMountEffect'
import {
  CashAmount,
  FetchBillingResponse,
  PaginationResponse,
} from '../../../../swagger'
import { useAuth } from '../../../Routes/AuthProvider'
import { CountryCoordinatorLicensingPaymentHistory } from '../CountryCoordinatorLicensingPaymentHistory'
import CountryCoordinatorLicensingTable from '../CountryCoordinatorLicensingTable'
import { BillingFilters } from '../interfaces'

export type CountryCoordinatorBillingViewProps = {
  pagination?: Pick<PaginationResponse, 'page' | 'pageSize' | 'totalCount'>
  handlePagination?: (_pagination: PaginationResponse) => void
  filters?: BillingFilters
  setFilters?: React.Dispatch<React.SetStateAction<BillingFilters>>
  billingData: FetchBillingResponse
}

const CountryCoordinatorBillingView: React.FC<
  CountryCoordinatorBillingViewProps
> = ({ pagination, handlePagination, filters, setFilters, billingData }) => {
  const { spacing } = useTheme()
  const { userDetails } = useAuth()
  const [totalBalance, setTotalBalance] = useState<CashAmount | undefined>()

  const {
    BillingTab: {
      fetchCountryCoordinatorTotalBalance: fetchTotalBalanceLoadingId,
      fetchBilling: fetchBillingLoadingId,
    },
  } = useLoadingIds()

  const fetchTotalBalance = async () => {
    const { totalOwed } = await paymentsApi.fetchCountryCoordinatorTotalBalance(
      {
        actorKey: Number(userDetails.actingAs),
      }
    )

    setTotalBalance(totalOwed)
  }

  const { triggerFetch: triggerFetchTotalBalance, loadingIds } =
    useLoadingContext({
      asyncFunction: fetchTotalBalance,
      loadingId: fetchTotalBalanceLoadingId,
    })

  useMountEffect(triggerFetchTotalBalance)

  const isLoading =
    loadingIds.has(fetchBillingLoadingId) ||
    loadingIds.has(fetchTotalBalanceLoadingId)

  return (
    <Card>
      <CountryCoordinatorLicensingTable
        countryCoordinatorLicensing={billingData.licensing?.billing?.data}
        countryCoordinatorTotalBalance={totalBalance}
        pagination={pagination as PaginationResponse}
        isAccountingView={false}
        handlePagination={handlePagination}
        filters={filters}
        setFilters={setFilters}
        actorKey={Number(userDetails.actingAs)}
        isLoading={isLoading}
      />
      <Divider sx={{ borderBottomWidth: spacing(0.625) }} />
      <CountryCoordinatorLicensingPaymentHistory
        actorKey={Number(userDetails.actingAs)}
      />
    </Card>
  )
}

export default CountryCoordinatorBillingView
